import { Config } from '../app/config/index.config';
import { salesEnvironment as env } from './sales.environment';
env.apiBaseUrl = Config.APIProductionServer;
env.authenticate = true;

// env.useAuthCookies = true;
export const environment = env;
